import { postApplePass } from 'api/IamApi/entities/ezpay';
import imageSrc from 'assets/add_to_apple_wallet_button.svg';
import React from "react";
import { IBiller, IImageResourcesProperties } from 'types/biller';
import { isIOSDevice } from 'utilities/helper';
export interface IAppleWalletButtonProps {
  href: string,
  biller: IBiller,
  barcodeText: string,
  itemNumber?: string,
  realm: string,
  language: string,
  payableItemTypeLabel: string,
  serviceFee: number;
  quantity?: number;
  amount?: number;
  location?: string;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const AppleWalletButton = (props: IAppleWalletButtonProps) => {
  const { href = "#", biller, barcodeText, itemNumber, realm, language, payableItemTypeLabel, serviceFee, quantity, amount, location } = props;
  // ApplePass download

  const base64ToBlob = (base64Data: string, contentType: string): Blob => {
    const byteCharacters = window.atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let index = 0; index < byteCharacters.length; index += 1) {
      byteNumbers[index] = byteCharacters.charCodeAt(index);
    }

    return new Blob([new Uint8Array(byteNumbers)], { type: contentType });
  };

  const downloadApplePass = async (): Promise<void> => {

    const imageResources = biller?.properties?.find(element => element.name === "ImageResources")?.properties as IImageResourcesProperties;
    const applePassRequest = {
      billerName: biller.billerName,
      itemNumber: itemNumber ?? "",
      logoUrl: imageResources?.logoURL,
      barcode: barcodeText,
      modifiedBy: 'ezPay',
      language: language,
      payableItemTypeLabel: payableItemTypeLabel,
      serviceFee: serviceFee,
      ...(quantity != null && quantity > 0 ? { quantity } : {}),
      ...(amount != null ? { amount } : {}),
      ...(location ? { location } : {}),
    };

    try {
      const res = await postApplePass(biller.clientId, applePassRequest, realm);
      const passContent = res?.data?.content;

      if (!passContent) {
        console.error('Could not fetch apple pass. Empty response content.');
        return;
      }

      const passBlob = base64ToBlob(passContent, 'application/vnd.apple.pkpass');
      const blobUrl = window.URL.createObjectURL(passBlob);

      if (isIOSDevice()) {
        window.location.assign(blobUrl);
        window.setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 60000);
        return;
      }

      const downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.href = blobUrl;
      downloadLink.target = '_self';
      downloadLink.download = 'appleWalletPass.pkpass';
      downloadLink.title = 'apple wallet downloaded to device';
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Could not fetch apple pass.', error);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    downloadApplePass();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>): void => {
    if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
      event.preventDefault();
      downloadApplePass();
    }
  };

  return (
    <a href={href} onClick={handleClick} onKeyDown={handleKeyDown}>
      <img
        src={imageSrc}
        alt="Apple wallet button"
        className="add-to-apple-wallet-button"
      />
    </a>
  );

}
